import translation from "zod-i18n-map/locales/en/zod.json";

export default {
  ...translation,
  custom: {
    no_empty_text: "Empty text is not allowed",
    email_regexp_error: "The target is incorrect format.",
    email_regexp_double_byte: "The target contains double-byte characters.",
    email_all_length_max:
      "The number of characters in all exceeds limit(max:{{value}})",
    phone_number_invalid: "The phone number is invalid.",
    postalCode: "Please enter a valid postal code.",
    stateProvinceCode: "Please select a state or province.",
    streetAddress: "Street address is required.",
    city: "Please enter a valid city.",
    invalidDateRange: "End date must be after the start date.",
    invalidBusinessHourRange: "End time must be after the start time.",
    invalid_only_date: "Invalid date",
    invalid_postal_code: "Please enter a valid postal code.",
    start_date_required: "Start date is required",
    required: "This field is required",
    port_required: "Port count is required",
    storage_required: "Storage size is required",
    invalid_mac_address: "Invalid MAC address",
    department_required: "Department is required",
    department_required_with_position:
      "Department is required when position is selected",
    country_code_required: "Country code is required",
    state_province_code_required: "State or province code is required",
    city_required: "City is required",
    street_address_required: "Street address is required",
    postal_code_required: "Postal code is required",
    postal_code_invalid: "Please enter a valid postal code.",
    max_length_error: "{{label}} must be {{maxLength}} characters or less",
    min_length_error: "{{label}} must be {{minLength}} characters or more",
    pattern_error: "{{label}} must be {{pattern}}",
    min_integer_error: "{{label}} must be {{min}} or more",
    max_integer_error: "{{label}} must be {{max}} or less",
    select_error: "{{label}} must be one of the following: {{options}}",
    required_error: "{{label}} is required",
    url_regexp_error: "Please enter a valid URL format for {{label}}",
    validation_error: "Invalid value for {{label}}",
    validation_system_error: "An error occurred while validating {{label}}",
    system_error: "An unexpected error occurred",
    place_name_required: "Place name is required when registering a new place",
    target_person_required: "Please select a person",
    whitespace_only: "Please enter characters other than whitespace",
    license: {
      invalid_date_range: "Start date must be earlier than expiration date",
      invalid_purchase_renewal_date:
        "Purchase date must be earlier than renewal date",
    },
    device: {
      responsible_person_required: "Please select a responsible person",
      responsible_person_start_date_required: "Please enter a start date",
      placement_required: "Please select a placement location",
      placement_date_required: "Please enter a placement date",
      warehousing_required: "Please select a warehousing placement location",
      warehousing_date_required: "Please enter a warehousing start date",
    },
    procurement_type_required: "Procurement type is required",
    network: {
      name_whitespace_only: "Must contain characters other than whitespace",
    },
    file: {
      file_max_exceeded: "The number of files exceeds the limit",
      file_size_exceeded: "The file size exceeds the limit",
      file_type_not_allowed: "Not allowed file type",
      file_extension_not_allowed: "Not allowed file extension",
    },
    lei_format_error: "LEI must be exactly 20 alphanumeric characters",
    duns_format_error: "DUNS must be exactly 9 digits",
  },
};
